import mutations from "@/apps/admin-console/store/mutations";
import actions from "@/apps/admin-console/store/actions";
import getters from "@/apps/admin-console/store/getters";
import IAdminState from "@/types/admin";

export default {
  namespaced: true,
  state: {
    adminAccount: null,
    jwt: null,
  } as IAdminState,
  actions,
  getters,
  mutations,
};
